import React, { useState } from 'react';
import { FaDesktop, FaCode, FaMobileAlt, FaPaintBrush } from 'react-icons/fa';
import OrderForm from './OrderForm'; // Import the OrderForm component
import { useAppContext } from './AppContext';
import Notification from './Notification';

const services = [
  {
    id: 1,
    icon: <FaDesktop className="text-4xl mb-4" />,
    title: 'Website Development',
    description: 'Custom website development tailored to your needs. Responsive and modern design with the latest technologies.',
  },
  {
    id: 2,
    icon: <FaCode className="text-4xl mb-4" />,
    title: 'Backend Development',
    description: 'Robust backend solutions using Node.js, Python, or other technologies. API development and database management.',
  },
  {
    id: 3,
    icon: <FaMobileAlt className="text-4xl mb-4" />,
    title: 'Mobile App Development',
    description: 'Cross-platform mobile applications for iOS and Android. Optimized for performance and user experience.',
    comingSoon: true, // Add a property to indicate "Coming Soon"
  },
  {
    id: 4,
    icon: <FaPaintBrush className="text-4xl mb-4" />,
    title: 'UI/UX Design',
    description: 'Creative design services for a seamless user experience. Includes wireframes, prototypes, and high-fidelity designs.',
  },
];

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const { loggedIn } = useAppContext();
  const [notification, setNotification] = useState(null);

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 3000); // Automatically hide notification after 3 seconds
  };


  const handleCloseNotification = () => {
    setNotification(null);
  };

  const handleOrderClick = (service) => {
    if (!service.comingSoon) {
      if (loggedIn) {
        setSelectedService(service);
      }

      else {
        showNotification(`hi  please Log in to be able to continue `)

      }
    }
  };

  const handleCloseForm = () => {
    setSelectedService(null);
  };

  return (
    <>
      {notification && (
        <Notification
          message={notification}
          onClose={handleCloseNotification}
        />
      )}
      <div className="relative p-3 showAnimation min-h-screen flex flex-col bg-gradient-to-r from-purple-600 via-sky-600 to-blue-900 dark:from-gray-600 dark:via-gray-900 dark:to-black text-white overflow-hidden duration-500">
        <div className="absolute pointer-events-none top-0 left-0 w-full h-full overflow-hidden z-10">
          <div className="diamond"></div>
          <div className="diamond diamond-2"></div>
          <div className="diamond diamond-3"></div>
          <div className="diamond diamond-4"></div>
          <div className="diamond diamond-5"></div>
          <div className="diamond diamond-6"></div>
        </div>
        <h2 className="text-2xl w-full font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Our Services</h2>
        {!loggedIn && (
          <> 
          <p className="text-2xl mb-4">Please log in or create an account to contact us.</p>
         <div className='w-full flex justify-center'>
          <a href="/" className="bg-green-500 dark:bg-green-950 text-center max-w-64 mt-6 hover:bg-green-700 mb-6 text-white font-bold py-2 px-4 rounded">Login / Singup</a>
          </div>
          </>


        )
        }
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map(service => (
            <div key={service.id} className="relative flex flex-col items-center text-center p-6 bg-white dark:bg-gray-700 bg-opacity-30 dark:bg-opacity-30 backdrop-blur-sm z-20 rounded-lg shadow-md flex-grow">
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
              <p>{service.description}</p>
              {service.comingSoon && (
                <span className="absolute top-2 text-xs right-2 text-red-500 font-bold bg-white dark:bg-gray-700 bg-opacity-40 px-2 py-1 rounded-md transform rotate-45 translate-x-1/4 translate-y-1/2">
                  Coming Soon
                </span>
              )}
              <div className="flex-grow"></div>
              <div className="flex justify-center mt-6 w-full">
                <button
                  onClick={() => handleOrderClick(service)}
                  className="flex items-center space-x-2 p-2 bg-inherit border-white border-4 text-gray-200 rounded-lg shadow-md dark:bg-gray-700 dark:text-white hover:-translate-y-1 transition-all duration-1000"
                  disabled={service.comingSoon}
                >
                  Order Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {selectedService && (
          <OrderForm
            service={selectedService}
            onClose={handleCloseForm}
          />
        )}
        
      </div>
    </>
  );
};

export default Services;
